const isEmail = (value: string) =>
  /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i.test(value)

export default isEmail
